module.exports = __webpack_public_path__ + "img/CreditCard.6c84462c.png";